export const blockIconsPrivacyandsecurityReportOffNew = (
	<span className='material-symbols-outlined'>report_off</span>
);
